import { useState } from 'react';
import Slider from "react-slick";
import { FileItem } from "../../models/types/common";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { MediaUrl } from "../../utils/configuration";
import SlickArrowLeft from "./arr-left";
import SlickArrowRight from "./arr-right";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useResponsive } from "../../hooks/mediaQuery";

export interface CarouselProps {
    files: FileItem[];
    isOpen: boolean;
    onClose: () => void;
    initIndex: number;
}

const PopupCarousel = ({ files, isOpen, onClose, initIndex }: CarouselProps) => {
    const [currentIndex, setCurrentIndex] = useState(initIndex)
    const { isXs, isLg, isXl } = useResponsive();

    if (!files || files.length === 0) {
        return null;
    }

    const settings = {
        customPaging: function (i: number) {
            return (
                <a>
                    <img src={`${MediaUrl}${files[i].path}`} alt={files[i].fileName} />
                </a>
            );
        },
        beforeChange: (current: number, next: number) => {
            setCurrentIndex(next)
        },
        dots: true,
        dotsClass: "slick-dots custom-dots slick-thumb",
        infinite: true,
        initialSlide: initIndex,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        nextArrow: <SlickArrowRight className="slider-arr-right" />,
        prevArrow: <SlickArrowLeft className="slider-arr-left" />,
        adaptiveHeight: true,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: true,
        gap: 10,
        className: "center",
    };

    return (
        <Dialog
            open={isOpen}
            sx={{ maxHeight: '100vh' }}
            PaperProps={{ style: { height: '100%' } }}
            maxWidth="xl"
            fullWidth
            onClose={onClose}
            fullScreen={isXs}
            className='dialog_camera'
        >
            <DialogTitle sx={{ m: 0, p: 2, pr: 5 }} className="bg-blue-100">
                Thư viện ảnh
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <div className="popup_carousel p-2">
                    <Slider {...settings}>
                        {files.map((file) => (
                            <div key={file.id} className="w-full h-[calc(100vh-250px)]">
                                <img
                                    src={MediaUrl + file.path}
                                    alt={file.fileName}
                                    className="w-full object-cover"
                                />
                            </div>
                        ))}
                    </Slider>
                    <div className='carousel_pagination'>
                        <p>{currentIndex + 1} / {files.length}</p>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default PopupCarousel;